import {ImportingDataTypes} from "../../types";
import {createInvalidPartSection, PreventionInvalidityCode} from "./shared";

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.partVisibility,
    sections: [
        createInvalidPartSection(),
        {
            sectionKey: 'invalidVisibility',
            sectionTitle: 'Invalid Visibility Values',
            invalidityCode: PreventionInvalidityCode.INVALID_BOOLEAN,
            fields: [
                {
                    key: 'partNumber',
                    label: 'Part Number',
                    type: 'text',
                    extractValue: (o) => typeof o === 'string' ? o : o?.partNo ?? null, // partNo is explicitly used since autocomplete provides partNo field
                    modifyRow: (row, val) => ({...row, partNumber: val})
                },
                {
                    key: 'isVisible',
                    label: 'Is Visible',
                    type: 'toggle',
                    modifyRow: (row, val) => ({...row, isVisible: val})
                },
                {
                    key: 'isVisibleForClient',
                    label: 'Is Visible For Client',
                    type: 'toggle',
                    modifyRow: (row, val) => ({...row, isVisibleForClient: val})
                }
            ]
        }
    ],
};
